module.exports = __webpack_public_path__ + "static/media/ill-handle-it.bc88a126.png";